export const defaultProdTable = {
  cod_produto: '',
  des_produto: '',
  qtd_est_atual: 0,
  un_venda: '',
  un_compra: '',
  val_peso_emb: 0,
};

export const defaultForm = {
  busca_produto: { label: undefined, value: undefined },
  cod_tipo_ajuste_origem: { label: undefined, value: undefined },
  cod_produto_derivado: { label: undefined, value: undefined },
  cod_tipo_ajuste_derivado: { label: undefined, value: undefined },
  qtd_ajuste: '',
  qtd_derivado: '',
};
